import PropTypes from "prop-types";

import { Box, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";

export const TenantSwitch = (props) => {
  // const [companyName, setCompanyName] = useState("B2B Rocket")
  const { companyName, showCompanyName } =
    useContext(WhiteLabelConfigurationContext);


  return (
    <>
      <Stack alignItems="center" direction="row" spacing={2} {...props}>
        <Box sx={{ flexGrow: 1 }}>
          {/* <Typography
            color="inherit"
            variant="h6"
          >
            {companyName}
          </Typography> */}
          {showCompanyName && (
            <Typography color="inherit" variant="h5" sx={{color: theme => theme.palette.text.primary}}>
              {companyName}
            </Typography>
          )}
        </Box>
        {/* <IconButton
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
        >
          <SvgIcon sx={{ fontSize: 16 }}>
            <ChevronDownIcon />
          </SvgIcon>
        </IconButton> */}
      </Stack>
      {/* <TenantPopover
        anchorEl={popover.anchorRef.current}
        onChange={popover.handleClose}
        onClose={popover.handleClose}
        open={popover.open}
        tenants={tenants}
      /> */}
    </>
  );
};

TenantSwitch.propTypes = {
  sx: PropTypes.object,
};
